import React, {Component} from "react";
import {Redirect} from "react-router-dom";

import Header from "../../../Containers/Header/Header/index";
import Footer from "../../../Containers/Footer/index";
import CalendarTopMenu from "../../../Containers/CalendarTopMenu/index";
import Loading from "../../../Containers/Loading";

import * as Utils from "../../../Utils";
import * as HomeworkService from "../../../../services/Student/HomeworkService";

class Calendar extends Component {
    state = {
        homeworkDic: {},
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
        isLoadingHide: false,
        isPageMove: false,
        link: ""
    }

    componentDidMount = () => {
        const {year, month} = this.state;
        this._isMounted = true;
        this.callMonthHomework(year, month);
        this.key = 0;
    }

    componentWillUnmount = () => {
        this._isMounted = false;
    }

    callMonthHomework = (year, month) => {
        this.getMonthHomework(year, month);
        this.setState({
            isLoadingHide: true
        });
    }

    getMonthHomework = (year, month) => {
        HomeworkService.getMonthHomework(year, month).then((response) => {
            if (response.status === 200) {
                let responseData = response.data;
                if (responseData.code === '0000') {
                    if (this._isMounted) {
                        //console.log(responseData.data);
                        this.setState({
                            homeworkDic: responseData.data
                        });
                    }
                } else {
                    alert(responseData.data);
                }
            } else {
                alert('GET HOMEWORK ERROR');
            }
        }).catch(response => {
            alert("SERVER ERROR");
        });
    }

    setCalendar = (year, month) => {
        const nowDate = new Date(year, month, 1);
        const lastDate = new Date(year, month + 1, 0).getDate();
        const monthsWeek = nowDate.getDay();
        const weekSeq = parseInt((parseInt(lastDate) + monthsWeek - 1) / 7) + 1;
        const firstDay = new Date(year, month, 1).getDay();

        let weeklist = [];
        for (var i = 0; i < weekSeq; i++) {
            let dateList = [];
            for (var j = 0; j < 7; j++) {
                if (i == 0 && j < firstDay) {
                    dateList.push(-1);
                } else if (i * 7 + j - firstDay + 1 > lastDate) {
                    dateList.push(-1);
                } else {
                    dateList.push(i * 7 + j - firstDay + 1);
                }
            }
            weeklist.push({id: i, date: dateList, day: j});
        }

        const result = weeklist.map(({id, day, date}) => {
                return (
                    <tr key={id}>
                        {date.map(
                            (item) => {
                                return (this.setCell(item));
                            }
                        )}
                    </tr>
                )
            }
        )
        return result;
    }

    onClickItem = (date, subject) => {
        let sub = "";
        switch (subject) {
            case "vocabulary":
                sub = "/app/vocabulary";
                break;
            case "reading":
                sub = "/app/reading";
                break;
            default:
                sub = "/error";
                break;
        }

        //바뀐 날짜 저장
        const newDate = new Date(this.state.year, this.state.month, date, 0, 0, 0);
        Utils.setDate(newDate);

        this.setState({
            isPageMove: true,
            link: sub
        })
    };

    getCSSType = (subject) => {
        switch (subject) {
            case "vocabulary":
                return "line-hw type-voca";
            case "speaking":
                return "line-hw type-speak";
            case "listening":
                return "line-hw type-listen";
            case "reading":
                return "line-hw type-read";
            case "writing":
                return "line-hw type-write";
        }
    };

    isCompleteHomework = (id) => {
        const {homeworkDic} = this.state;

        for (let i = 0; i < homeworkDic[id].length; i++) {
            if (homeworkDic[id][i].doneDate == null)
                return false;
        }
        return true;
    }

    isDoneInTimeHomework = (id) => {
        const {homeworkDic} = this.state;

        for (let i = 0; i < homeworkDic[id].length; i++) {
            if (homeworkDic[id][i].doneDate > homeworkDic[id][i].dueDate)
                return false;
        }
        return true;
    }

    isRemainHomework = (id) => {
        const {homeworkDic} = this.state;

        for (let i = 0; i < homeworkDic[id].length; i++) {
            if (new Date() > homeworkDic[id][i].dueDate)
                return true;
        }
        return false;
    }

    setCell = (day) => {
        const {homeworkDic} = this.state;
        const isNotNullValue = (day > 0 && day in homeworkDic && homeworkDic[day].length > 0);
        const isRemainHomework = (isNotNullValue) ? this.isRemainHomework(day) : false;
        this.key = (this.key + 1) % 100;

        return (
            <td key={this.key}>
                {(isRemainHomework) ? this.setEffectBox(day) : this.setNormalBox(day)}
            </td>
        );
    }

    setEffectBox = (day) => {
        return (
            <div className="box-effect">
                {this.setNormalBox(day)}</div>
        );
    }

    setNormalBox = (day) => {
        const {homeworkDic} = this.state;
        const isNotNullValue = (day > 0 && day in homeworkDic && homeworkDic[day].length > 0);
        const isComplete = (isNotNullValue) ? this.isCompleteHomework(day) : false;
        const isDoneInTime = (isComplete) ? this.isDoneInTimeHomework(day) : false;

        return (
            <div>
                <div className="box-date">
                    {(day > 0) ? <strong>{day}</strong> : <strong-alpha>{day}</strong-alpha>}
                    {(isComplete) && <span className={(isDoneInTime) ? "icon-hwcheck" : "icon-hwcheck"}></span>}
                </div>
                <div className="box-hw">
                    {(isNotNullValue) && homeworkDic[day].map(
                        (item, i) => {
                            return (
                                <div key={i}
                                     className={(isComplete) ? this.getCSSType(item.subject) : this.getCSSType(item.subject).concat(" hw")}
                                     onClick={() => this.onClickItem(day, item.subject)}>
                                    <span>{Utils.capitalizeFirstLetter(item.subject)}</span>
                                    <em>{(isComplete) ? "복습하기" : "숙제하기"}</em>
                                </div>
                            )
                        }
                    )}
                </div>
            </div>
        );
    }

    onPrev = (year, month) => {
        this.setState({
            year: year,
            month: month,
            isLoadingHide: false
        });

        this.callMonthHomework(year, month);
    }

    onNext = (year, month) => {
        this.setState({
            year: year,
            month: month,
            isLoadingHide: false
        });

        this.callMonthHomework(year, month);
    }

    render() {
        const {isPageMove, link, isLoadingHide} = this.state;

        if (isPageMove)
            return <Redirect to={link}/>

        if (!this.state.isLoadingHide)
            return (<Loading/>);

        return (
            <div className="beaconWrapper">
                <Header selectedIndex={1}/>
                <div className="allconWrapper">
                    <div className="contentsWrapper">
                        <h2 className="screenOut">오늘의 숙제</h2>
                        <CalendarTopMenu onPrev={this.onPrev} onNext={this.onNext}/>
                        <div className="pageContents">
                            <div className="calWrapper">
                                <table className="tbTbl">
                                    <colgroup>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                        <col width="14.28%"/>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th className="date-sun">SUN</th>
                                        <th>MON</th>
                                        <th>TUE</th>
                                        <th>WED</th>
                                        <th>THU</th>
                                        <th>FRI</th>
                                        <th className="date-sat">SAT</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.setCalendar(this.state.year, this.state.month)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />

            </div>
        );
    }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/Pages/Student/Calendar/index.js